/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resumes: NonNullable<unknown>, resumePlural: NonNullable<unknown>, jobs: NonNullable<unknown>, jobPlural: NonNullable<unknown>, applications: NonNullable<unknown>, appPlural: NonNullable<unknown> }} Dashboard_Stats_SummaryInputs */

const en_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} resume${i?.resumePlural} ready, ${i?.jobs} job${i?.jobPlural} tracked, ${i?.applications} application${i?.appPlural} sent`)
};

const de_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} Lebenslauf${i?.resumePlural}, ${i?.jobs} Stelle${i?.jobPlural} verfolgt, ${i?.applications} Bewerbung${i?.appPlural} gesendet`)
};

const fr_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} CV${i?.resumePlural}, ${i?.jobs} emploi${i?.jobPlural} suivi${i?.jobPlural}, ${i?.applications} candidature${i?.appPlural} envoyée${i?.appPlural}`)
};

const es_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} currículum${i?.resumePlural}, ${i?.jobs} empleo${i?.jobPlural} en seguimiento, ${i?.applications} solicitud${i?.appPlural} enviada${i?.appPlural}`)
};

const it_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} curriculum vitae${i?.resumePlural}, ${i?.jobs} lavoro${i?.jobPlural} tracciato, ${i?.applications} candidatura${i?.appPlural} inviata`)
};

const nl_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} cv${i?.resumePlural}, ${i?.jobs} baan${i?.jobPlural} bijgehouden, ${i?.applications} sollicitatie${i?.appPlural} verzonden`)
};

const pl_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} CV${i?.resumePlural}, ${i?.jobs} ogłoszenie${i?.jobPlural} śledzone, ${i?.applications} aplikacja${i?.appPlural} wysłana`)
};

const fi_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} ansioluetteloa, ${i?.jobs} työpaikkaa seurannassa, ${i?.applications} hakemusta lähetetty`)
};

const da_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} CV${i?.resumePlural}, ${i?.jobs} job${i?.jobPlural} sporet, ${i?.applications} ansøgning${i?.appPlural} sendt`)
};

const sv_dashboard_stats_summary = /** @type {(inputs: Dashboard_Stats_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.resumes} CV${i?.resumePlural}, ${i?.jobs} jobb${i?.jobPlural} spårade, ${i?.applications} ansökan${i?.appPlural} skickade`)
};

/**
* | output |
* | --- |
* | "{resumes} resume{resumePlural} ready, {jobs} job{jobPlural} tracked, {applications} application{appPlural} sent" |
*
* @param {Dashboard_Stats_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_stats_summary = /** @type {((inputs: Dashboard_Stats_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_stats_summary(inputs)
	if (locale === "fr") return fr_dashboard_stats_summary(inputs)
	if (locale === "es") return es_dashboard_stats_summary(inputs)
	if (locale === "it") return it_dashboard_stats_summary(inputs)
	if (locale === "nl") return nl_dashboard_stats_summary(inputs)
	if (locale === "pl") return pl_dashboard_stats_summary(inputs)
	if (locale === "fi") return fi_dashboard_stats_summary(inputs)
	if (locale === "da") return da_dashboard_stats_summary(inputs)
	if (locale === "sv") return sv_dashboard_stats_summary(inputs)
	return en_dashboard_stats_summary(inputs)
});